import '../styles/dashboard-tabs.css';

export default function DashboardTabs({
  items,
  activeIndex = 0,
  variant = 'secondary',
  containerClassName = '',
  tabClassName = '',
}) {
  const containerClasses = `db-tabs db-tabs--${variant} ${containerClassName}`.trim();

  return (
    <div className={containerClasses}>
      {items.map((item, index) => (
        <a
          className={`db-tab ${tabClassName} ${index === activeIndex ? 'is-active' : ''}`.trim()}
          href={item.href}
          key={item.label}
        >
          {item.label}
        </a>
      ))}
    </div>
  );
}
